import { Button, Form, Modal } from 'antd';
import React from 'react';

const AddEmailModal = (props) => {
  const { showModal, setShowModal, usersWithoutEmail, refetchRef } = props;
  const [form] = Form.useForm();

  return (
    <Modal
      maskClosable={false}
      centered
      open={showModal}
      footer={null}
      closable={false}
      destroyOnHidden
      rootClassName="add-email-modal"
    >
      <h2>Missing Email ID</h2>
      <p>The following external approvers don’t have an email ID.</p>
      <ol>
        {usersWithoutEmail?.map((user) => (
          <li key={user?.id}>{user?.name}</li>
        ))}
      </ol>
      <p>
        Please ask the system admin to add it from the Setup tab so they can
        receive email notifications.
      </p>
      <Form form={form} layout="vertical" className="stage-config">
        <div className="form-buttons mt-15">
          <Button
            shape="round"
            type="primary"
            className="save-button"
            htmlType="submit"
            onClick={() => {
              setShowModal(false);
              refetchRef?.current?.refetchStageDetails();
            }}
            id="add-email-okay-button"
          >
            Okay
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddEmailModal;
